import React, { useMemo } from "react";

import classes from "./ProductOption.module.css";
import classNames from "classnames";
const ProductOption = (props) => {
  const { options = [], optionClass, parentSku } = props;

  const displayOptions = useMemo(
    () =>
      options.map(({ option_label, value_label }) => {
        const key = `${option_label}${value_label}`;
        const optionLabelString = `${option_label} :`;
        return (
          <div
            key={key}
            className={classNames(classes.optionLabel, "minicartoptionLabel")}
          >
            <dt className={classes.optionName}>{optionLabelString}</dt>
            <dd className={classes.optionValue}>{value_label}</dd>
          </div>
        );
      }),
    [classes, options]
  );

  if (displayOptions.length === 0) {
    return null;
  }

  return (
    <dl className={classNames(classes.options, "miniCartoption", optionClass)}>
      {parentSku ? (
        <div className={classNames(classes.optionLabel, "minicartoptionLabel")}>
          <dt className={classes.optionName}>Parent Sku : </dt>
          <dd className={classes.optionValue}>{parentSku}</dd>
        </div>
      ) : null}
      {displayOptions}
    </dl>
  );
};

export default ProductOption;
